<template>
    <div class="head">
        <img src="/static/image/logo-title.png" class="logo-title" alt="回到官网首页"  @click="toHomePage">
        <div class="btn-box">
          <i class="icon icon-language-translate"></i>
          <i class="icon icon-help-circle"></i>
        </div>
    </div>
    <div class="login-box">
      <!-- 账号密码登录 -->
      <div class="login-form-box">
        <p class="title">登录到</p>
        <p class="logo-name">WALK PLAY</p>
        <p v-if="defPageStatus || pageType['vcodeLogin'] || pageType['pwdLogin'] || pageType['wxLogin']" class="regist-lab"><span class="lab unselectable-text">没有账号吗？</span><span class="to-reg unselectable-text" @click="setPage('vcodeReg')">注册新账号</span></p>
        <p v-if="defPageStatus || pageType['vcodeReg'] || pageType['resetPwdAcount'] || pageType['inputPwd']" class="regist-lab"><span class="lab unselectable-text">已有账号？</span><span class="to-reg unselectable-text" @click="setPage('pwdLogin')">登录</span></p>
        <div class="input-box">
          <div v-if="defPageStatus || pageType['wxLogin']" class="wechat-text"><span>请使用微信扫一扫登录</span><span class="refresh-btn">刷新</span><i class="icon icon-qrcode-refresh"></i></div>
          <div v-if="defPageStatus || pageType['wxLogin']" class="wechat-img-box">
            <img class="qrcode-img" :src="'/static/image/qrcode.jpg'" alt="">
          </div>
          <div v-if="defPageStatus || pageType['vcodeReg'] || pageType['vcodeLogin'] || pageType['pwdLogin'] || pageType['resetPwdAcount']" class="row-input-box"><i class="icon icon-input-user"></i><input type="text" placeholder="请输入邮箱/手机号"></div>
          <!-- <div v-if="defPageStatus" class="row-input-box"><i class="icon icon-input-user"></i><input type="text" placeholder="请输入邮箱"></div>
          <div v-if="defPageStatus" class="row-input-box"><i class="icon icon-input-user"></i><input type="text" placeholder="请输入手机号"></div> -->
          <div v-if="defPageStatus || pageType['vcodeReg'] || pageType['pwdLogin'] || pageType['inputPwd']" class="row-input-box"><i class="icon icon-input-lock"></i><input type="password" placeholder="请输入密码"></div>
          <div v-if="defPageStatus || pageType['inputPwd']" class="row-input-box"><i class="icon icon-input-lock"></i><input type="passsword" placeholder="请再次输入新密码"></div>
          <div v-if="defPageStatus 
           || pageType['vcodeReg'] 
           || pageType['vcodeLogin']
           || pageType['resetPwdAcount']"
          class="vcode-box">
            <div class="row-input-box"><input type="text" placeholder="请输入验证码"></div>
            <div class="send-vcode-btn unselectable-text" @click="getPhoneCode">{{ count == '0' ? '发送验证码' : count + '秒后重新发送' }}</div>
          </div>
        </div>
        <div v-if="defPageStatus || pageType['pwdLogin']" class="rr">
          <div>
            <input type="checkbox" id="remember-me">
            <label class="remember-me-lab unselectable-text" for="remember-me">记住账号</label>
          </div>
          <span class="forget-pwd unselectable-text" @click="setPage('resetPwdAcount')">忘记密码？</span>
        </div>
        <div v-if="defPageStatus || pageType['vcodeReg']" class="rr">
          <div>
            <input type="checkbox" id="remember-me">
            <label class="remember-me-lab unselectable-text" for="remember-me">我已阅读并同意</label>
            <label class="protocol-text unselectable-text">《用户协议及隐私条款》</label>
          </div>
        </div>
        <div v-if="defPageStatus || pageType['vcodeLogin'] || pageType['pwdLogin']" class="button-box"><button class="login-btn">登录</button></div>
        <div v-if="defPageStatus || pageType['resetPwdAcount']" class="button-box"><button class="next-btn" @click="setPage('inputPwd')">下一步</button></div>
        <div v-if="defPageStatus || pageType['vcodeReg']" class="button-box"><button class="register-btn">注册</button></div>
        <div v-if="defPageStatus || pageType['inputPwd']" class="button-box"><button class="register-btn">提交</button></div>
        <div v-if="defPageStatus || pageType['vcodeReg']" class="register-link-box">
          <span class="to-phone-reg unselectable-text" @click="setPage('wxLogin')">使用微信登录</span>
        </div>
        <div v-if="defPageStatus || pageType['pwdLogin']" class="login-link-box">
          <span class="to-wechat unselectable-text" @click="setPage('wxLogin')">使用微信登录</span>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span class="to-sms unselectable-text" @click="setPage('vcodeLogin')">使用邮箱/手机验证码登录</span>
        </div>
        <div v-if="defPageStatus || pageType['vcodeLogin']" class="login-link-box">
          <span class="to-wechat unselectable-text" @click="setPage('wxLogin')">使用微信登录</span>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span class="to-sms unselectable-text" @click="setPage('pwdLogin')">使用账号密码登录</span>
        </div>
        <div v-if="defPageStatus || pageType['wxLogin']" class="login-link-box">
          <span class="to-wechat unselectable-text" @click="setPage('vcodeLogin')">使用邮箱/手机验证码登录</span>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span class="to-sms unselectable-text" @click="setPage('pwdLogin')">使用账号密码登录</span>
        </div>
      </div>
    </div>

    <div class="footer">
      <p class="icp-text">Copyright @ 2024-2025 Walk Play. All Rights Reserved</p>
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n';

export default {
  name: 'Login',
  data(){
    return {
      tm: null,
      defPageStatus: false,
      pageType: {
        'pwdLogin': false,
        'vcodeLogin': false,
      'vcodeReg': false,
      'resetPwdAcount': false,
      'inputPwd': false,
      'wxLogin': false,
      },
      page: 'wxLogin',
      timer: null,
      count: '0'
    }
  },
  created(){
    document.title = 'resetPwdEmail';
    const { tm, locale } = useI18n();
    this.tm = tm;
    this.pageType[this.page] = true;
  },
  methods:{
    resetPageStatus(){
      this.pageType['pwdLogin'] = false;
      this.pageType['vcodeLogin'] = false;
      this.pageType['vcodeReg'] = false;
      this.pageType['resetPwdAcount'] = false;
      this.pageType['inputPwd'] = false;
      this.pageType['wxLogin'] = false;
    },
    setPage(page){
      this.resetPageStatus()
      this.pageType[page] = true;
      this.page = page;
    },
    toHomePage(){
      console.log(1111)
      window.location.href = '/'; 
    },
    getPhoneCode() {

      const TIME_COUNT = 60;
      if (!this.timer) {
         this.count = TIME_COUNT;
         this.codeShow = false;
         this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
               this.count--;
            } else {
               this.codeShow = true;
               clearInterval(this.timer);
               this.timer = null;
            }
         }, 1000)
      }
   }
   

  }
}
</script>

<style>
html{
  width: 100%;
}
body{
  width: 100%;
  background: url('/public/static/image/background-img.jpg') no-repeat;
  background-size: 100vw 100vh;
}

#app{
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  min-width: 900px;
}

.head{
    width: 100%;
    height: 56px;
    background: rgba(17,31,51,1);
    display: flex;
    align-items: center; /* 垂直居中 */
    justify-content: space-between; /* 水平居中，如果需要的话 */
}
.head .logo-title{
    line-height: 56px;
    cursor: pointer;
    margin-left: 24px;
}
.head .btn-box{
  margin-right: 32px;
}
.head .btn-box .icon{
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.head .btn-box .icon.icon-language-translate{
  margin-right: 28px;
}

.login-box{
  width: 100%;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中，如果需要的话 */
  flex: 1;
}

.login-box *{
  text-align: center;
}

.login-box .title{
  font-size: 36px;
  opacity: 90%;
  color: #fff;
  line-height: 44px;
}

.login-box .logo-name{
  font-size: 36px;
  opacity: 90%;
  color: #fff;
  line-height: 44px;
  margin-top: 4px;
}

.login-box .regist-lab{
  line-height: 22px;
  font-size: 14px;
  color: #fff;
  margin-top: 24px;
}

.login-box .regist-lab .lab{
  opacity: 55%;
}

.login-box .regist-lab .to-reg{
  opacity: 90%;
  margin-left: 8px;
  cursor: pointer;
}

.input-box{
  width: 400px;
  margin-top: 48px;
}

.input-box div.row-input-box{
  width: 400px;
  height: 40px;
  background-color: #2C2C2C;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  border: 1px solid #DCDCDC;
  border-radius: 3px;
}

.input-box div.row-input-box>input{
  line-height: 38px;
  background-color: #2C2C2C;
  border: none;
  color: #ffffff;
  text-align: left;
  flex: 1;
}

.input-box .vcode-box{
  display: flex;
  justify-content: space-between;
}

.input-box .vcode-box div.row-input-box{
  width: 246px;
  padding-left: 10px;
}

.input-box .vcode-box .send-vcode-btn{
  width: 128px;
  height: 40px;
  background-color: #2C2C2C;
  margin-bottom: 24px;
  border: 1px solid #DCDCDC;
  border-radius: 3px;
  text-align: center;
  line-height: 38px;
  cursor: pointer;
  color: #FFFFFF;
}

.input-box>div>i{
  width: 18px;
  height: 18px;
  margin-left: 12px;
  margin-right: 12px;
}

.input-box .wechat-text{
  font-size: 14px;
  line-height: 22px;
  color: #FFFFFF;
  opacity: 90%;
}
.input-box .wechat-text .refresh-btn{
  color: #9480FF;
  margin-left: 8px;
  cursor: pointer;
}
.input-box .wechat-text .icon{
  width: 16px;
  height: 16px;
  margin: 0;
  position: relative;
  top: 3px;
  cursor: pointer;
}

.wechat-img-box{
  margin-top: 16px;
  text-align: center;
}
.wechat-img-box .qrcode-img{
width: 172px;
height: 172px;
}

.icon{
  display: inline-block;
}
.icon.icon-input-user{
  background-image: url('/public/static/image/input-icon-user.png');
}
.icon.icon-input-lock{
  background-image: url('/public/static/image/input-icon-lock-on.png');
}
.icon.icon-language-translate{
  background-image: url('/public/static/image/icon-language-translate.png');
}
.icon.icon-help-circle{
  background-image: url('/public/static/image/icon-help-circle.png');
}

.icon.icon-qrcode-refresh{
  background-image: url('/public/static/image/icon-qrcode-refresh.png');
}


.rr{
  display: flex;
  justify-content: space-between;
}
.rr .remember-me-lab,
.rr .forget-pwd{
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
}

.rr .remember-me-lab{
  color: #FFFFFF;
  opacity: 90%;
  margin-left: 8px;
}
.rr .forget-pwd,
.rr .protocol-text{
  color: #9480FF;
  cursor: pointer;
}


.button-box,
.button-box{
  width: 400px;
}

.button-box .login-btn,
.button-box .register-btn,
.button-box .next-btn{
  width: 400px;
  height: 40px;
  background-image: linear-gradient(to right, #9503D2, #5659DD);
  border: none;
  color: #FFFFFF;
  font-size: 16px;
  opacity: 90%;
  border-radius: 3px;
  cursor: pointer;
  margin-top: 44px;
}

.login-link-box,
.register-link-box{
  font-size: 14px;
  line-height: 22px;
  color: #9480FF;
  margin-top: 28px;
}

.register-link-box .to-phone-reg,
.login-link-box .to-wechat,
.login-link-box .to-sms{
  cursor: pointer;
}

.footer{
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中，如果需要的话 */
}

.footer .icp-text{
  color: #FFFFFF;
  opacity: 35%;
}

.unselectable-text {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+ */
  user-select: none; /* Standard syntax */
}

</style>